import * as React from 'react';
import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { Switch, Redirect } from 'react-router';
import LandingPageContainer from './components/landingPage/LandingPageContainer';
import DownloadPageContainer from './components/download/DownloadPageContainer';
import ErrorContainer from './error/ErrorContainer';
import ProgressPageContainer from './components/callback/ProgressPageContainer';
import DownloadProgressContainer from './components/downloadprogress/DownloadProgressContainer';
import AccountErrorContainer from './error/account/AccountErrorContainer';
import ListIccidPageContainer from './components/listIccids/ListIccidPageContainer';
import UserInfoPageContainer from './components/userinfo/UserInfoPageContainer';

class AppRouter extends React.Component {
    render(): ReactNode {
        return (
            <div>
                    <Switch>
                        <Route exact path="/app" component={LandingPageContainer}/>
                        <Route exact path="/download" component={DownloadPageContainer}/>
                        <Route exact path="/error" component={ErrorContainer}/>
                        <Route exact path="/accountError" component={AccountErrorContainer}/>
                        <Route exact path="/callback" component={ProgressPageContainer}/>
                        <Route exact path="/downloadInitiated" component={DownloadProgressContainer}/>
                        <Route exact path="/list" component={ListIccidPageContainer}/>
                        <Route exact path="/userInfo" component={UserInfoPageContainer}/>
                        <Redirect exact from="/" to="/app"/>
                        <Redirect to="/error"/>
                    </Switch>
            </div>
        );
    }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/AppRouter.tsx